import HeadingSettings from './HeadingSettings';
export default HeadingSettings;